module.exports = __webpack_public_path__ + "img/biokeep-full.1de2d9fb.png";